<div class="cdp-breadcrumbs">
    <ng-container *ngIf="showTenantSwitcher && hasTenantContext">
        <span
            class="tenant-switcher"
            [hcPop]="tenantSwitcher"
            title="Switch tenant"
            tabindex="0"
            (keydown.enter)="tenantSwitcher.open()"
        >
            {{ tenantCode || ' — ' }} <span class="icon-left icon-caret-down"></span>
        </span>
        <span class="icon-left icon-right icon-chev-right"></span>
    </ng-container>
    <span>{{ navbarTabName }}</span>
    <span *ngFor="let breadcrumb of breadcrumbs; let last = last">
        <span class="icon-left icon-right icon-chev-right"></span>
        <span *ngIf="!breadcrumb.routerLink">{{ breadcrumb.label }}</span>
        <a *ngIf="breadcrumb.routerLink" [routerLink]="getRouterLink(breadcrumb.routerLink)">{{ breadcrumb.label }}</a>
    </span>
</div>

<hc-pop #tenantSwitcher [showArrow]="false" [autoFocus]="true">
    <cdp-tenant-switcher (tenantSelected)="tenantSwitcher.close()"></cdp-tenant-switcher>
</hc-pop>
